import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.286 6.918l-.714.72-4.254-4.223.714-.72a1.01 1.01 0 011.418 0l2.836 2.816a.99.99 0 010 1.407zm-9.576 9.65l.03-2.236a1.999 1.999 0 00-2.03-2.015l-2.253.027 7.453-7.511 4.254 4.223-7.454 7.512zM19.413 4.807L15.159.583a2.016 2.016 0 00-2.836 0L.296 12.667c-.636.632-.178 1.711.722 1.7l3.687-.047a.999.999 0 011.016 1.008l-.047 3.662c-.011.893 1.076 1.348 1.712.716L19.413 7.622a1.98 1.98 0 000-2.815z",
  fillRule: "evenodd"
});

var Bookmark6Icon = function Bookmark6Icon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
Bookmark6Icon.defaultProps = {
  size: 1.5
};
export default Bookmark6Icon;